export interface RadioOptionProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  disabled?: boolean;
  label: string;
  name: string;
}

export function RadioOption({
  checked,
  onCheckedChange,
  disabled = false,
  label,
  name,
}: RadioOptionProps) {
  return (
    <label
      className={[
        'inline-flex items-center gap-2 select-none',
        disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer',
      ].join(' ')}
    >
      <button
        type="button"
        role="radio"
        aria-checked={checked}
        data-name={name}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        className={[
          'flex items-center justify-center w-4 h-4 rounded-full border',
          'transition-colors duration-motion-default ease-cursor-out',
          checked ? 'border-action' : 'border-border',
        ].join(' ')}
      >
        {checked && <span className="block w-2 h-2 rounded-full bg-action" />}
      </button>
      <span className="text-body text-foreground">{label}</span>
    </label>
  );
}
